import { useCallback } from 'react';

import type { ShortUrlInfo } from '#src/app/shared/hooks/shortUrls';

import type { ShareChannel } from '../shared/types';

import { useShareShortUrls } from './shortUrls';

type Options<CH extends ShareChannel = ShareChannel> = {
	disableShortLinks?: boolean;
	getUrl: (channel: CH) => string;
};

export function useGetShareShortUrlInfo<CH extends ShareChannel = ShareChannel>(
	channels: readonly CH[],
	options: Options<CH>,
): (channel: CH) => ShortUrlInfo {
	const shortUrls: Partial<Record<CH, ShortUrlInfo>> = useShareShortUrls(channels, options);

	return useCallback(
		(channel: CH) => {
			const info: ShortUrlInfo | undefined = shortUrls[channel];
			if (!info) {
				throw new Error(`Missing share url for ${channel}`);
			}
			return info;
		},
		[shortUrls],
	);
}
